// extracted by mini-css-extract-plugin
export default {"box":"badge_box__1ZTsh"};